import { Controller } from "@hotwired/stimulus"
import Tagify from "@yaireo/tagify"

export default class extends Controller {
  static values = {
    mode: String
  }

  connect() {
    const emailMode = this.modeValue === "email"
    const tagifyOptions = {
      delimiters: ",",           // Split on comma
      trim: true,                 // Trim whitespace
      duplicates: false,          // Don't allow duplicates
      addTagOnBlur: true,         // Add tag when input loses focus
      editTags: false,            // Don't allow editing tags inline
      maxTags: Infinity,          // No limit on tags
      dropdown: {
        enabled: 0                // Always show suggestions (0 = always)
      },
      // Output plain comma-separated values instead of JSON
      originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(',')
    }

    if (emailMode) {
      tagifyOptions.pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      tagifyOptions.validate = (tagData) => {
        const value = tagData?.value?.trim()
        if (!value) return "Email address is required"
        if (!tagifyOptions.pattern.test(value)) return "Enter a valid email address"
        return true
      }
      tagifyOptions.dropdown.enabled = 0
    }

    // Initialize Tagify on the input element
    this.tagify = new Tagify(this.element, tagifyOptions)

    // Bind the update method to this controller instance
    this.updateOriginalInput = this.updateOriginalInput.bind(this)

    // Listen to multiple Tagify events to ensure value is updated
    this.tagify.on("add", this.updateOriginalInput)
    this.tagify.on("remove", this.updateOriginalInput)
    this.tagify.on("change", this.updateOriginalInput)

    // Load existing values if any
    if (this.element.value) {
      this.tagify.addTags(this.element.value.split(",").map(v => v.trim()).filter(Boolean))
    }
  }

  updateOriginalInput() {
    // Get all tag values as comma-separated string
    // this.tagify.value is an array of objects like [{value: "domain.com"}, ...]
    const tagValues = this.tagify.value || []
    const tags = tagValues.map(tag => tag.value).join(",")

    // Update the live form value that Rails and browser validation read.
    this.element.value = tags
    this.element.setAttribute("value", tags)
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
    this.element.form?.dispatchEvent(new Event("input", { bubbles: true }))
    this.element.form?.dispatchEvent(new Event("change", { bubbles: true }))
    this.tagify?.dropdown?.hide()
  }

  disconnect() {
    // Clean up Tagify instance when controller is disconnected
    if (this.tagify) {
      this.tagify.destroy()
    }
  }
}
